module.exports = __webpack_public_path__ + "img/MobileDevelopment.b844761a.webp";